module.exports = __webpack_public_path__ + "img/credt-card-white.2fb4ac7f.svg";